export enum TaxReturnFrequency {
    Monthly = 'Monthly',
    Quarterly = 'Quarterly'
}
